'use client'

import { useEffect } from 'react'
import { useAuth } from '@/components/providers/supabase-auth-provider'
import { Header } from '@/components/header'
import { DashboardHeader } from '@/components/dashboard/header'
import { usePathname } from 'next/navigation'

export function ConditionalHeader() {
  const { user, isLoading: authIsLoading } = useAuth()
  const pathname = usePathname()
  const isDashboardPath = pathname?.startsWith('/dashboard')
  
  // Log the current state for debugging (simplified)
  useEffect(() => {
    if (isDashboardPath) return;
    console.log('ConditionalHeader - Auth state from context:', {
      isAuthenticated: !!user,
      userEmail: user?.email,
      isLoading: authIsLoading,
      pathname
    });
  }, [user, authIsLoading, pathname, isDashboardPath]);
  
  if (isDashboardPath) {
    return null;
  }
  
  // Show a minimal placeholder during initial auth load if not on dashboard
  if (authIsLoading && !isDashboardPath) {
    return <div className="h-16 border-b"></div>;
  }
  
  if (user) { // Simply check if user object exists
    console.log('ConditionalHeader - Rendering DashboardHeader because user exists');
    return <DashboardHeader />;
  }
  
  console.log('ConditionalHeader - Rendering regular Header');
  return <Header />;
} 